module.exports = __webpack_public_path__ + "media/customizations/montaneranch/logo-new-77cbbf419c77b52c9a06ff246af1cac8.png";